import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LectionarySource, LectionarySourceService } from '../../services/lectionary-source.service';

@Component({
  selector: 'app-psalter-search',
  templateUrl: './psalter-search.component.html',
  styleUrls: ['./psalter-search.component.css']
})
export class PsalterSearchComponent implements OnInit {

  @Output() searchItems = new EventEmitter<PsalterSearchModel>();
  public lectionarySources: LectionarySource[]; 
  public chapters: number[]; 
  public listsLoaded: boolean;

  public model: PsalterSearchModel;

  constructor(
    private lectionarySourceSvc: LectionarySourceService
    ) { }

  ngOnInit() {
    this.listsLoaded = false;
    this.model = new PsalterSearchModel();    
    this.getSearchValues();
  }

  public getSearchValues() {

    this.chapters = [];
    for(var i =1; i<=150; i++) {
      this.chapters.push(i);
    } 
  
    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data;
      }
    )
 
    Promise.all([lectionarySourcePromise]).then(
      (data) => { 
        console.log("All promises are completed");
        this.listsLoaded = true;
        this.getSavedModel();
      }
    )

  }


  public getSavedModel() {
    var savedModel = localStorage["psalterSearch"];
    console.log("getSavedModel", savedModel);
    if (savedModel != undefined) {
      this.model = JSON.parse(savedModel);
      console.log("parsedModel", this.model);
      this.search();
    }
  }

  public search() {
    console.log("Search", this.model);
    localStorage["psalterSearch"] = JSON.stringify(this.model);
    this.searchItems.emit(this.model); 
  }


}

export class PsalterSearchModel {
  public LectionarySource: number;
  public Chapter: number; 
}
